<template>
    <v-row class="ma-n1">
        <v-col class="pa-1" cols="auto">
            <v-btn-toggle v-model="mode" mandatory color="primary" background-color="white" @change="emitMode">
                <v-btn v-for="item in modes" :key="item.value" :value="item.value" :disabled="item.disabled" text height="40">
                    {{ item.text }}
                </v-btn>
            </v-btn-toggle>
        </v-col>
        <v-col class="pa-1" cols="auto">
            <v-card outlined class="d-flex align-center" height="40">
                <v-btn text tile height="38" min-width="40" class="px-0" :disabled="mode == 'custom'" @click="prev"> <v-icon>mdi-chevron-left</v-icon> </v-btn>
                <v-divider vertical />
                <v-btn text tile height="38" min-width="40" class="px-0" :disabled="mode == 'custom'" @click="next"> <v-icon>mdi-chevron-right</v-icon> </v-btn>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import dayjs from "@/plugins/vue-dayjs";

import { initDuration } from "./search-duration";

export default {
    props: {
        /** @type {import('vue').PropType<[string, string]>} */
        value: { type: Array, default: () => initDuration() },
    },
    data: () => ({
        mode: "month",
        // 배열을 그대로 들고 있으면 Vue2 가 원소 교체를 감지하지 못해 문자열로 보관한다.
        stored: JSON.stringify([null, null]),
    }),
    computed: {
        modes() {
            return [
                { value: "year", text: "연간" },
                { value: "month", text: "월간" },
                { value: "day", text: "일간" },
                // "기간" 은 직접 고른 구간임을 알려주는 표시 — 눌러서 들어가는 모드가 아니다.
                { value: "custom", text: "기간", disabled: this.mode != "custom" },
            ];
        },
        base() {
            let [home] = JSON.parse(this.stored);
            return dayjs.tz(home);
        },
    },
    methods: {
        ////////////////////////////////////////////////////////////////////////
        // 들어온 구간이 어느 단위와 딱 맞아떨어지는지 역산해 버튼을 맞춘다.
        // 예) 2026-08-01 ~ 2026-08-31 이면 "월간", 어디에도 안 맞으면 "기간".
        ////////////////////////////////////////////////////////////////////////
        sync() {
            this.stored = JSON.stringify([...(this.value || initDuration())]);

            let [home, last] = JSON.parse(this.stored);
            let unit = ["year", "month", "day"].find((unit) => {
                if (!dayjs.tz(home).isSame(last, unit)) return false;

                let sameHome = dayjs.tz(home).startOf(unit).format("YYYY-MM-DD") == home;
                let sameLast = dayjs.tz(last).endOf(unit).format("YYYY-MM-DD") == last;
                return sameHome && sameLast;
            });

            this.mode = unit || "custom";
        },

        emit() {
            this.$emit("input", JSON.parse(this.stored));
        },

        // 단위를 바꾸면 "오늘이 속한" 해당 단위로 이동한다.
        emitMode() {
            if (this.mode == "custom") return;

            this.stored = JSON.stringify(initDuration(this.mode));
            this.emit();
        },

        prev() {
            this.move(this.base.subtract(1, this.mode));
        },
        next() {
            this.move(this.base.add(1, this.mode));
        },
        move(base) {
            this.stored = JSON.stringify([
                //
                base.startOf(this.mode).format("YYYY-MM-DD"),
                base.endOf(this.mode).format("YYYY-MM-DD"),
            ]);
            this.emit();
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped></style>
